export const formatItemsOwnerships = (items, applicants) =>
  items.map(item => {
    const oldOwnerships = item?.ownerships ?? [];
    const ownerships = applicants.map(applicant =>
      oldOwnerships.find(ownership => ownership.applicantId === applicant.id))
      .filter(ownership => ownership !== undefined);
    return ({ ...item, ownerships });
  });
